document.addEventListener("DOMContentLoaded", function () {
  var sections = document.querySelectorAll(".custom-photo-canvas-page");

  sections.forEach(function (sectionEl) {
    var sectionId = sectionEl.dataset.sectionId;
    if (!sectionId) return;

    var pricePerSqm = parseFloat(sectionEl.dataset.pricePerSqm || "830");

  var workspace = document.getElementById("cpp-workspace-" + sectionId);
  var uploadInput = document.getElementById("photo-upload-" + sectionId);
  var triggerUpload = document.getElementById("trigger-upload-" + sectionId);
  var loader = document.getElementById("cpp-upload-loader-" + sectionId);

  var configurator = document.getElementById("cpp-configurator-" + sectionId);
  var stage = document.getElementById("cpp-stage-" + sectionId);
  var introCard = document.getElementById("cpp-intro-card-" + sectionId);
  var showConfigButton = document.getElementById("cpp-show-config-" + sectionId);

  var sizeSelect = document.getElementById("cpp-size-select-" + sectionId);
  var settingsSelect = document.getElementById("cpp-settings-select-" + sectionId);
  var settingsToggle = document.getElementById("cpp-settings-toggle-" + sectionId);
  var settingsPanel = document.getElementById("cpp-settings-panel-" + sectionId);
  var settingsCloseTop = document.getElementById("cpp-settings-close-top-" + sectionId);
  var settingsSize = document.getElementById("cpp-settings-size-" + sectionId);
  var mirrorToggle = document.getElementById("cpp-mirror-toggle-" + sectionId);
  var bwToggle = document.getElementById("cpp-bw-toggle-" + sectionId);

  var previewWrap = document.getElementById("cpp-preview-wrap-" + sectionId);
  var canvasOuter = document.getElementById("cpp-canvas-outer-" + sectionId);
  var canvasInner = document.getElementById("cpp-canvas-inner-" + sectionId);
  var posterShell = document.getElementById("cpp-poster-shell-" + sectionId);
  var posterMat = document.getElementById("cpp-poster-mat-" + sectionId);
  var previewImage = document.getElementById("cpp-preview-image-" + sectionId);

  var bottomRuler = document.getElementById("cpp-bottom-ruler-" + sectionId);
  var sideRuler = document.getElementById("cpp-side-ruler-" + sectionId);
  var rulerWidth = document.getElementById("cpp-ruler-width-" + sectionId);
  var rulerHeight = document.getElementById("cpp-ruler-height-" + sectionId);

  var cartButton = document.getElementById("cpp-add-to-cart-" + sectionId);
  var cartPrice = document.getElementById("cpp-cart-price-" + sectionId);

  var hiddenSizePreset = document.getElementById("hidden-size-preset-" + sectionId);
  var hiddenWidth = document.getElementById("hidden-width-" + sectionId);
  var hiddenHeight = document.getElementById("hidden-height-" + sectionId);
  var hiddenArea = document.getElementById("hidden-area-" + sectionId);
  var hiddenPrice = document.getElementById("hidden-price-" + sectionId);
  var hiddenOrientation = document.getElementById("hidden-orientation-" + sectionId);

  var materialToggle = document.getElementById("cpp-material-toggle-" + sectionId);
  var materialPanel = document.getElementById("cpp-material-panel-" + sectionId);
  var materialSummary = document.getElementById("cpp-material-summary-" + sectionId);

  var materialTypeInput = document.getElementById("hidden-material-type-" + sectionId);
  var canvasTypeInput = document.getElementById("hidden-canvas-type-" + sectionId);
  var frameTypeInput = document.getElementById("hidden-frame-type-" + sectionId);

  var canvasTypeSelect = document.getElementById("cpp-canvas-type-" + sectionId);
  var materialTypeButtons = sectionEl.querySelectorAll(".cpp-material-type");
  var materialFrameButtons = sectionEl.querySelectorAll(".cpp-material-frame");

  var posterPanel = document.getElementById("cpp-poster-panel-" + sectionId);
  var posterFrameButtons = sectionEl.querySelectorAll("[data-poster-frame]");
  var posterMatButtons = sectionEl.querySelectorAll("[data-poster-mat]");
  var posterMatWidthWrap = document.getElementById("cpp-poster-mat-width-wrap-" + sectionId);
  var posterMatWidthSelect = document.getElementById("cpp-poster-mat-width-" + sectionId);

  var posterFrameHidden = document.getElementById("hidden-poster-frame-color-" + sectionId);
  var posterMatHidden = document.getElementById("hidden-poster-mat-enabled-" + sectionId);
  var posterMatWidthHidden = document.getElementById("hidden-poster-mat-width-" + sectionId);

  var posterTooltipBtn = document.getElementById("cpp-poster-tooltip-trigger-" + sectionId);
  var posterTooltip = document.getElementById("cpp-poster-tooltip-" + sectionId);

  var sizeOptionButtons = sectionEl.querySelectorAll(".cpp-size-option");
  var sizeGroupHeads = sectionEl.querySelectorAll(".cpp-size-group__head");
  var faqButtons = sectionEl.querySelectorAll(".custom-photo-canvas-page__faq-question");

  var imageUrl = "";
  var naturalWidth = 0;
  var naturalHeight = 0;
  var fitScale = 1;
  var currentScale = 1;
  var posX = 0;
  var posY = 0;
  var mirrorX = 1;

  var isDragging = false;
  var dragStartX = 0;
  var dragStartY = 0;
  var dragOriginX = 0;
  var dragOriginY = 0;

  var currentMaterialType = "canvas";
  var currentCanvasType = "Pânză întinsă pe șasiu";
  var currentFrameStyle = "none";
  var currentFrameValue = "Fără ramă";

  var currentPosterFrame = "Neagră";
  var currentPosterMat = "Nu";
  var currentPosterMatWidth = "5 cm";

  function formatLei(value) {
    return Math.round(value) + " Lei";
  }

  function getPriceKey(widthCm, heightCm) {
  var a = Math.min(widthCm, heightCm);
  var b = Math.max(widthCm, heightCm);
  return a + "x" + b;
}

function calculatePrice(widthCm, heightCm) {
  var sizeKey = getPriceKey(widthCm, heightCm);

  var PRICE_MAP = {
    canvas: {
      "30x40": 65,
      "40x60": 105,
      "60x90": 195,
      "90x120": 370,
      "40x40": 80,
      "60x60": 140,
      "90x90": 280
    },
    framed_canvas: {
      "30x40": 135,
      "40x60": 185,
      "60x90": 310,
      "90x120": 535,
      "40x40": 150,
      "60x60": 235,
      "90x90": 425
    },
    poster: {
      "30x40": 80,
      "40x60": 115,
      "60x90": 220,
      "90x120": 405,
      "40x40": 90,
      "60x60": 160,
      "90x90": 315
    },
    rolled_canvas: {
      "30x40": 0,
      "40x60": 0,
      "60x90": 0,
      "90x120": 0,
      "40x40": 0,
      "60x60": 0,
      "90x90": 0
    }
  };

  if (currentMaterialType === "poster") {
    return PRICE_MAP.poster[sizeKey] || 0;
  }

  if (currentCanvasType === "Pânză rulată") {
    return PRICE_MAP.rolled_canvas[sizeKey] || 0;
  }

  if (currentFrameStyle !== "none") {
    return PRICE_MAP.framed_canvas[sizeKey] || 0;
  }

  return PRICE_MAP.canvas[sizeKey] || 0;
}
function updateCartPrice() {
  if (!sizeSelect) return;

  var size = parseSize(sizeSelect.value);
  var widthCm = size.width;
  var heightCm = size.height;
  var price = calculatePrice(widthCm, heightCm);

  if (cartPrice) {
    cartPrice.textContent = formatLei(price);
  }

  if (hiddenPrice) {
    hiddenPrice.value = Math.round(price) + " Lei";
  }
}

  function getOrientation(widthCm, heightCm) {
    if (widthCm === heightCm) return "Pătrat";
    return widthCm > heightCm ? "Orizontală" : "Verticală";
  }

  function parseSize(value) {
    var parts = String(value || "50x70").split("x");
    return {
      width: parseInt(parts[0], 10) || 50,
      height: parseInt(parts[1], 10) || 70
    };
  }

  function getPosterMatInsetPx() {
    if (currentMaterialType !== "poster" || currentPosterMat !== "Da") {
      return 0;
    }

    if (currentPosterMatWidth === "3 cm") return 18;
    if (currentPosterMatWidth === "7 cm") return 42;
    return 30;
  }

  function setWorkspaceToConfigurator() {
    if (workspace) workspace.classList.add("is-configurator-visible");
    if (configurator) configurator.setAttribute("aria-hidden", "false");

    window.setTimeout(function () {
      updateSize();
    }, 30);
  }

  function showLoader() {
    if (loader) loader.classList.add("is-visible");
  }

  function hideLoader() {
    if (loader) loader.classList.remove("is-visible");
  }

  function enableStageDim() {
    if (stage) stage.classList.add("is-dimmed");
  }

  function disableStageDim() {
    if (stage) stage.classList.remove("is-dimmed");
  }

  function openSettingsPanel() {
    if (!settingsPanel) return;
    settingsPanel.classList.add("is-open");
    settingsPanel.setAttribute("aria-hidden", "false");

    if (settingsToggle) settingsToggle.classList.add("is-active");
    if (materialToggle) materialToggle.classList.remove("is-active");
  }

  function closeSettingsPanel() {
    if (!settingsPanel) return;
    settingsPanel.classList.remove("is-open");
    settingsPanel.setAttribute("aria-hidden", "true");

    if (settingsToggle) settingsToggle.classList.remove("is-active");
  }

  function openMaterialPanel() {
    if (!materialPanel) return;
    materialPanel.classList.add("is-open");
    materialPanel.setAttribute("aria-hidden", "false");

    if (stage) stage.classList.add("is-material-open");
    if (materialToggle) materialToggle.classList.add("is-active");
    if (settingsToggle) settingsToggle.classList.remove("is-active");
  }

  function closeMaterialPanel() {
    if (!materialPanel) return;
    materialPanel.classList.remove("is-open");
    materialPanel.setAttribute("aria-hidden", "true");

    if (stage) stage.classList.remove("is-material-open");
    if (materialToggle) materialToggle.classList.remove("is-active");
  }

  function syncSettingsSelect() {
    if (settingsSelect && sizeSelect) {
      settingsSelect.value = sizeSelect.value;
    }
  }

  function syncSelectedSizeButtons() {
    if (!sizeOptionButtons.length || !sizeSelect) return;

    sizeOptionButtons.forEach(function (button) {
      button.classList.toggle(
        "is-selected",
        button.getAttribute("data-size") === sizeSelect.value
      );
    });
  }

  function getActiveViewport() {
    if (currentMaterialType === "poster" && canvasInner && posterMat) {
      var innerRect = canvasInner.getBoundingClientRect();
      var matRect = posterMat.getBoundingClientRect();

      return {
        offsetX: Math.round(matRect.left - innerRect.left),
        offsetY: Math.round(matRect.top - innerRect.top),
        width: Math.max(1, Math.round(matRect.width)),
        height: Math.max(1, Math.round(matRect.height))
      };
    }

    if (!canvasInner) {
      return { offsetX: 0, offsetY: 0, width: 0, height: 0 };
    }

    return {
      offsetX: 0,
      offsetY: 0,
      width: Math.max(1, canvasInner.clientWidth),
      height: Math.max(1, canvasInner.clientHeight)
    };
  }

  function clampPosition() {
  if (!previewImage || !naturalWidth || !naturalHeight) return;

  var viewport = getActiveViewport();
  var frameW = viewport.width;
  var frameH = viewport.height;

  var imgW = naturalWidth * currentScale;
  var imgH = naturalHeight * currentScale;

  var minX = Math.min(0, frameW - imgW);
  var minY = Math.min(0, frameH - imgH);

  if (imgW <= frameW) {
    posX = (frameW - imgW) / 2;
  } else {
    posX = Math.max(minX, Math.min(0, posX));
  }

  if (imgH <= frameH) {
    posY = (frameH - imgH) / 2;
  } else {
    posY = Math.max(minY, Math.min(0, posY));
  }
}

  function updateImageTransform() {
  if (!previewImage || !naturalWidth || !naturalHeight) return;

  var renderedWidth = naturalWidth * currentScale;

  previewImage.style.transformOrigin = "top left";

  if (mirrorX === -1) {
    previewImage.style.transform =
      "translate(" +
      (posX + renderedWidth) +
      "px, " +
      posY +
      "px) scale(" +
      (-currentScale) +
      ", " +
      currentScale +
      ")";
  } else {
    previewImage.style.transform =
      "translate(" +
      posX +
      "px, " +
      posY +
      "px) scale(" +
      currentScale +
      ", " +
      currentScale +
      ")";
  }
}

  function applyMirror() {
  if (!previewImage || !naturalWidth || !naturalHeight) return;

  var oldMirrorX = mirrorX;
  var newMirrorX = mirrorToggle && mirrorToggle.checked ? -1 : 1;

  if (oldMirrorX !== newMirrorX) {
    var viewport = getActiveViewport();
    var frameW = viewport.width;
    var imgW = naturalWidth * currentScale;
    posX = frameW - imgW - posX;
  }

  mirrorX = newMirrorX;
  clampPosition();
  updateImageTransform();
}
function applyBlackWhite() {
  if (!canvasInner) return;

  if (bwToggle && bwToggle.checked) {
    canvasInner.classList.add("is-bw");
  } else {
    canvasInner.classList.remove("is-bw");
  }
}

  function fitImageToCanvas() {
  if (!naturalWidth || !naturalHeight) return;

  var viewport = getActiveViewport();
  var frameW = viewport.width;
  var frameH = viewport.height;

  if (!frameW || !frameH) return;

  var scaleX = frameW / naturalWidth;
  var scaleY = frameH / naturalHeight;

  /* IMPORTANT:
     si pentru poster cu paspartu folosim COVER, nu CONTAIN */
  fitScale = Math.max(scaleX, scaleY);
  currentScale = fitScale;

  var imgW = naturalWidth * currentScale;
  var imgH = naturalHeight * currentScale;

  posX = (frameW - imgW) / 2;
  posY = (frameH - imgH) / 2;

  clampPosition();
  updateImageTransform();
}

  function applyPreviewFrame(style) {
  if (!canvasOuter) return;

  canvasOuter.classList.remove(
    "frame-none",
    "frame-white",
    "frame-black",
    "frame-gold",
    "poster-preview",
    "poster-frame-black",
    "poster-frame-white",
    "poster-mat-3",
    "poster-mat-5",
    "poster-mat-7",
    "has-poster-mat",
    "no-poster-mat"
  );

  canvasOuter.style.removeProperty("--poster-mat-inset");

  if (posterShell) {
    posterShell.style.background = "transparent";
    posterShell.style.inset = "0";
    posterShell.style.padding = "0";
  }

  if (posterMat) {
    posterMat.style.background = "transparent";
    posterMat.style.inset = "0";
    posterMat.style.padding = "0";
  }

  if (currentMaterialType === "canvas") {
    if (!style || style === "none") {
      canvasOuter.classList.add("frame-none");
      return;
    }

    if (style === "white") {
      canvasOuter.classList.add("frame-white");
      return;
    }

    if (style === "black") {
      canvasOuter.classList.add("frame-black");
      return;
    }

    if (style === "gold") {
      canvasOuter.classList.add("frame-gold");
      return;
    }

    canvasOuter.classList.add("frame-none");
    return;
  }

  canvasOuter.classList.add("poster-preview");

  if (currentPosterFrame === "Albă") {
    canvasOuter.classList.add("poster-frame-white");
  } else {
    canvasOuter.classList.add("poster-frame-black");
  }

  if (currentPosterMat === "Da") {
    var inset = "30px";

    if (currentPosterMatWidth === "3 cm") {
      inset = "18px";
      canvasOuter.classList.add("poster-mat-3");
    } else if (currentPosterMatWidth === "7 cm") {
      inset = "42px";
      canvasOuter.classList.add("poster-mat-7");
    } else {
      inset = "30px";
      canvasOuter.classList.add("poster-mat-5");
    }

    canvasOuter.classList.add("has-poster-mat");
    canvasOuter.style.setProperty("--poster-mat-inset", inset);

    if (posterShell) {
      posterShell.style.background = "#f7f7f5";
      posterShell.style.inset = "0";
      posterShell.style.padding = "0";
    }

    if (posterMat) {
      posterMat.style.background = "transparent";
      posterMat.style.inset = "var(--poster-mat-inset)";
      posterMat.style.padding = "0";
    }
  } else {
    canvasOuter.classList.add("no-poster-mat");
    canvasOuter.style.setProperty("--poster-mat-inset", "0px");

    if (posterShell) {
      posterShell.style.background = "transparent";
      posterShell.style.inset = "0";
      posterShell.style.padding = "0";
    }

    if (posterMat) {
      posterMat.style.background = "transparent";
      posterMat.style.inset = "0";
      posterMat.style.padding = "0";
    }
  }
}

  function syncRulersToImage() {
    if (!previewWrap || !canvasInner || !bottomRuler || !sideRuler) return;

    var wrapRect = previewWrap.getBoundingClientRect();
    var innerRect = canvasInner.getBoundingClientRect();
    var rulerGap = 18;

    var left = innerRect.left - wrapRect.left;
    var top = innerRect.top - wrapRect.top;
    var width = innerRect.width;
    var height = innerRect.height;

    bottomRuler.style.left = left + "px";
    bottomRuler.style.width = width + "px";
    bottomRuler.style.top = top + height + rulerGap + "px";

    sideRuler.style.left = left + width + rulerGap + "px";
    sideRuler.style.top = top + "px";
    sideRuler.style.height = height + "px";
  }

  function updateMaterialSummary() {
    if (!materialSummary) return;

    if (currentMaterialType === "poster") {
      var summary = "Poster înrămat · " + currentPosterFrame;
      summary += currentPosterMat === "Da"
        ? " · Paspartu " + currentPosterMatWidth
        : " · Fără paspartu";
      materialSummary.textContent = summary;
      return;
    }

    if (currentCanvasType === "Pânză rulată") {
      materialSummary.textContent = "Tablou canvas · Pânză rulată";
      return;
    }

    materialSummary.textContent = "Tablou canvas · " + currentFrameValue;
  }

  function updateMaterialUI() {
  var framesWrap = document.getElementById("cpp-material-frames-" + sectionId);
  var canvasTypeWrap = canvasTypeSelect
    ? canvasTypeSelect.closest(".cpp-material-panel__section")
    : null;

  materialTypeButtons.forEach(function (btn) {
    btn.classList.toggle(
      "is-active",
      btn.getAttribute("data-material-type") === currentMaterialType
    );
  });

  materialFrameButtons.forEach(function (btn) {
    btn.classList.toggle(
      "is-active",
      btn.getAttribute("data-frame-style") === currentFrameStyle
    );
  });

  posterFrameButtons.forEach(function (btn) {
    btn.classList.toggle(
      "is-active",
      btn.getAttribute("data-poster-frame") === currentPosterFrame
    );
  });

  posterMatButtons.forEach(function (btn) {
    btn.classList.toggle(
      "is-active",
      btn.getAttribute("data-poster-mat") === currentPosterMat
    );
  });

  if (currentMaterialType === "canvas") {
    if (canvasTypeWrap) {
      canvasTypeWrap.style.display = "block";
      canvasTypeWrap.style.visibility = "visible";
      canvasTypeWrap.style.position = "static";
      canvasTypeWrap.style.pointerEvents = "auto";
    }

    if (posterPanel) {
      posterPanel.style.display = "none";
      posterPanel.style.visibility = "hidden";
      posterPanel.style.position = "absolute";
      posterPanel.style.pointerEvents = "none";
    }

    if (currentCanvasType === "Pânză întinsă pe șasiu") {
      if (framesWrap) {
        framesWrap.style.display = "block";
        framesWrap.style.visibility = "visible";
        framesWrap.style.position = "static";
        framesWrap.style.pointerEvents = "auto";
      }
    } else {
      if (framesWrap) {
        framesWrap.style.display = "none";
        framesWrap.style.visibility = "hidden";
        framesWrap.style.position = "absolute";
        framesWrap.style.pointerEvents = "none";
      }

      currentFrameStyle = "none";
      currentFrameValue = "Fără ramă";
    }

    if (posterMatWidthWrap) {
      posterMatWidthWrap.style.display = "none";
    }

    if (posterShell) {
      posterShell.style.background = "transparent";
    }

    if (posterMat) {
      posterMat.style.background = "transparent";
    }

    applyPreviewFrame(currentFrameStyle);
  } else {
    if (canvasTypeWrap) {
      canvasTypeWrap.style.display = "none";
      canvasTypeWrap.style.visibility = "hidden";
      canvasTypeWrap.style.position = "absolute";
      canvasTypeWrap.style.pointerEvents = "none";
    }

    if (framesWrap) {
      framesWrap.style.display = "none";
      framesWrap.style.visibility = "hidden";
      framesWrap.style.position = "absolute";
      framesWrap.style.pointerEvents = "none";
    }

    if (posterPanel) {
      posterPanel.style.display = "block";
      posterPanel.style.visibility = "visible";
      posterPanel.style.position = "static";
      posterPanel.style.pointerEvents = "auto";
    }

    currentFrameStyle = "none";
    currentFrameValue = "Fără ramă";

    if (posterMatWidthWrap) {
      posterMatWidthWrap.style.display = currentPosterMat === "Da" ? "block" : "none";
    }

    applyPreviewFrame("poster");

    if (posterShell) {
      posterShell.style.background = currentPosterMat === "Da" ? "#f7f7f5" : "transparent";
    }

    if (posterMat) {
      posterMat.style.background = "transparent";
    }
  }

  if (materialTypeInput) {
    materialTypeInput.value =
      currentMaterialType === "poster" ? "Poster înrămat" : "Tablou canvas";
  }

  if (canvasTypeInput) {
    canvasTypeInput.value = currentCanvasType;
  }

  if (frameTypeInput) {
    frameTypeInput.value =
      currentMaterialType === "poster"
        ? "Ramă " + currentPosterFrame.toLowerCase()
        : currentFrameValue;
  }

  if (posterFrameHidden) {
    posterFrameHidden.value = currentPosterFrame;
  }

  if (posterMatHidden) {
    posterMatHidden.value = currentPosterMat;
  }

  if (posterMatWidthHidden) {
    posterMatWidthHidden.value = currentPosterMat === "Da" ? currentPosterMatWidth : "";
  }

  updateMaterialSummary();
  updateCartPrice();

  if (naturalWidth && naturalHeight) {
    fitImageToCanvas();
    applyMirror();
    syncRulersToImage();
  }
}

  function updateSize() {
  if (!sizeSelect || !canvasOuter || !canvasInner) return;

  var size = parseSize(sizeSelect.value);
  var widthCm = size.width;
  var heightCm = size.height;
  var orientation = getOrientation(widthCm, heightCm);
  var price = calculatePrice(widthCm, heightCm);

  var baseWidth = 420;
  var aspectRatio = heightCm / widthCm;
  var displayWidth = baseWidth;
  var displayHeight = Math.round(baseWidth * aspectRatio);

  if (displayHeight > 520) {
    displayHeight = 520;
    displayWidth = Math.round(displayHeight / aspectRatio);
  }

  canvasOuter.style.width = displayWidth + "px";
  canvasInner.style.width = displayWidth + "px";
  canvasInner.style.height = displayHeight + "px";

  if (bottomRuler) {
    bottomRuler.style.width = displayWidth + "px";
    bottomRuler.style.left = "0";
    bottomRuler.style.transform = "none";
  }

  if (sideRuler) {
    sideRuler.style.height = displayHeight + "px";
  }

  if (rulerWidth) rulerWidth.textContent = widthCm + " cm";
  if (rulerHeight) rulerHeight.textContent = heightCm + " cm";
  if (settingsSize) settingsSize.textContent = widthCm + " x " + heightCm + " cm";
  if (cartPrice) cartPrice.textContent = formatLei(price);

  if (hiddenSizePreset) hiddenSizePreset.value = widthCm + "x" + heightCm + " cm";
  if (hiddenWidth) hiddenWidth.value = widthCm + " cm";
  if (hiddenHeight) hiddenHeight.value = heightCm + " cm";
  if (hiddenArea) hiddenArea.value = ((widthCm * heightCm) / 10000).toFixed(2) + " m²";
  if (hiddenPrice) hiddenPrice.value = Math.round(price) + " Lei";
  if (hiddenOrientation) hiddenOrientation.value = orientation;

  syncSettingsSelect();
  syncSelectedSizeButtons();

  if (naturalWidth && naturalHeight) {
    fitImageToCanvas();
    applyMirror();
    syncRulersToImage();
  }

  updateMaterialUI();
}

  function loadImageToPreview(src, onDone) {
    if (!previewImage || !src) {
      hideLoader();
      return;
    }

    var tempImg = new Image();

    tempImg.onload = function () {
      try {
        naturalWidth = tempImg.naturalWidth;
        naturalHeight = tempImg.naturalHeight;

        previewImage.onload = null;
        previewImage.src = src;

        fitImageToCanvas();
        applyMirror();
        syncRulersToImage();

        if (typeof onDone === "function") {
          onDone();
        }

        updateMaterialUI();
      } catch (error) {
        console.error("loadImageToPreview error:", error);
        hideLoader();
      }
    };

    tempImg.onerror = function () {
      console.error("Imaginea nu a putut fi încărcată.");
      hideLoader();
    };

    tempImg.src = src;
  }

  function bindDragging() {
    if (!canvasInner) return;

    function startDrag(clientX, clientY) {
      if (!naturalWidth || !naturalHeight) return;
      isDragging = true;
      canvasInner.classList.add("is-dragging");
      dragStartX = clientX;
      dragStartY = clientY;
      dragOriginX = posX;
      dragOriginY = posY;
    }

    function moveDrag(clientX, clientY) {
      if (!isDragging) return;

      var deltaX = clientX - dragStartX;
      var deltaY = clientY - dragStartY;

      posX = dragOriginX + (mirrorX === -1 ? -deltaX : deltaX);
      posY = dragOriginY + deltaY;

      clampPosition();
      updateImageTransform();
      syncRulersToImage();
    }

    function endDrag() {
      isDragging = false;
      canvasInner.classList.remove("is-dragging");
    }

    canvasInner.addEventListener("mousedown", function (event) {
      event.preventDefault();
      startDrag(event.clientX, event.clientY);
    });

    window.addEventListener("mousemove", function (event) {
      moveDrag(event.clientX, event.clientY);
    });

    window.addEventListener("mouseup", endDrag);

    canvasInner.addEventListener("touchstart", function (event) {
      if (!event.touches || !event.touches.length) return;
      var touch = event.touches[0];
      startDrag(touch.clientX, touch.clientY);
    }, { passive: true });

    window.addEventListener("touchmove", function (event) {
      if (!isDragging || !event.touches || !event.touches.length) return;
      var touch = event.touches[0];
      moveDrag(touch.clientX, touch.clientY);
    }, { passive: true });

    window.addEventListener("touchend", endDrag);
  }

  function initSizeOptions() {
    if (sizeOptionButtons.length) {
      sizeOptionButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          var value = button.getAttribute("data-size");
          if (!value || !sizeSelect) return;
          sizeSelect.value = value;
          updateSize();
        });
      });
    }

    if (sizeGroupHeads.length) {
      sizeGroupHeads.forEach(function (head) {
        head.addEventListener("click", function () {
          var group = head.closest(".cpp-size-group");
          if (!group) return;
          group.classList.toggle("is-open");
        });
      });
    }
  }

  function initFaq() {
    if (!faqButtons.length) return;

    faqButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var item = button.closest(".custom-photo-canvas-page__faq-item");
        if (!item) return;

        var answer = item.querySelector(".custom-photo-canvas-page__faq-answer");
        var icon = item.querySelector(".custom-photo-canvas-page__faq-icon");
        var isOpen = button.classList.contains("active");

        faqButtons.forEach(function (otherButton) {
          otherButton.classList.remove("active");

          var otherItem = otherButton.closest(".custom-photo-canvas-page__faq-item");
          if (!otherItem) return;

          var otherAnswer = otherItem.querySelector(".custom-photo-canvas-page__faq-answer");
          var otherIcon = otherItem.querySelector(".custom-photo-canvas-page__faq-icon");

          if (otherAnswer) otherAnswer.style.display = "none";
          if (otherIcon) otherIcon.textContent = "+";
        });

        if (!isOpen) {
          button.classList.add("active");
          if (answer) answer.style.display = "block";
          if (icon) icon.textContent = "−";
        }
      });
    });
  }

  if (triggerUpload && uploadInput) {
    triggerUpload.addEventListener("click", function () {
      uploadInput.click();
    });

    uploadInput.addEventListener("change", function (event) {
      var file = event.target.files && event.target.files[0];
      if (!file) return;

      imageUrl = URL.createObjectURL(file);

      if (mirrorToggle) mirrorToggle.checked = false;
      mirrorX = 1;

      showLoader();

      window.setTimeout(function () {
        setWorkspaceToConfigurator();

        loadImageToPreview(imageUrl, function () {
  hideLoader();

  if (window.innerWidth <= 749) {
    disableStageDim();
    if (introCard) introCard.style.display = "none";
  } else {
    enableStageDim();
    if (introCard) introCard.style.display = "block";
  }
});
      }, 700);
    });
  }

  if (showConfigButton) {
    showConfigButton.addEventListener("click", function () {
      disableStageDim();
      if (introCard) introCard.style.display = "none";
      updateSize();
    });
  }

  if (settingsToggle) {
    settingsToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      if (!settingsPanel) return;

      closeMaterialPanel();

      if (settingsPanel.classList.contains("is-open")) {
        closeSettingsPanel();
      } else {
        openSettingsPanel();
      }
    });
  }

  if (settingsCloseTop) {
    settingsCloseTop.addEventListener("click", function () {
      closeSettingsPanel();
    });
  }

  if (settingsSelect) {
    settingsSelect.addEventListener("change", function () {
      if (!sizeSelect) return;
      sizeSelect.value = settingsSelect.value;
      updateSize();
    });
  }

  if (mirrorToggle) {
    mirrorToggle.addEventListener("change", function () {
      applyMirror();
      syncRulersToImage();
    });
  }
  
  if (bwToggle) {
  bwToggle.addEventListener("change", function () {
    applyBlackWhite();
  });
}

  if (materialToggle) {
    materialToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      if (!materialPanel) return;

      closeSettingsPanel();

      if (materialPanel.classList.contains("is-open")) {
        closeMaterialPanel();
      } else {
        openMaterialPanel();
      }
    });
  }

  if (canvasTypeSelect) {
    canvasTypeSelect.addEventListener("change", function () {
      currentCanvasType = this.value;
      updateMaterialUI();
    });
  }

  if (materialTypeButtons.length) {
    materialTypeButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        currentMaterialType = this.getAttribute("data-material-type") || "canvas";
        updateMaterialUI();
      });
    });
  }

  if (materialFrameButtons.length) {
    materialFrameButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        currentFrameStyle = this.getAttribute("data-frame-style") || "none";
        currentFrameValue = this.getAttribute("data-frame-value") || "Fără ramă";
        updateMaterialUI();
      });
    });
  }

  if (posterFrameButtons.length) {
    posterFrameButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        currentPosterFrame = this.getAttribute("data-poster-frame") || "Neagră";
        updateMaterialUI();
      });
    });
  }

  if (posterMatButtons.length) {
    posterMatButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        currentPosterMat = this.getAttribute("data-poster-mat") || "Nu";
        updateMaterialUI();
      });
    });
  }

  if (posterMatWidthSelect) {
    posterMatWidthSelect.addEventListener("change", function () {
      currentPosterMatWidth = this.value || "5 cm";
      updateMaterialUI();
    });
  }

  if (posterTooltipBtn && posterTooltip) {
    posterTooltipBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      posterTooltip.classList.toggle("is-open");
    });
  }

  if (cartButton) {
    cartButton.addEventListener("click", function () {
      var form = document.getElementById("custom-photo-canvas-form-" + sectionId);
      if (form) form.submit();
    });
  }

  document.addEventListener("click", function (e) {
    if (settingsPanel && settingsToggle) {
      if (!settingsPanel.contains(e.target) && !settingsToggle.contains(e.target)) {
        closeSettingsPanel();
      }
    }

    if (materialPanel && materialToggle) {
      if (!materialPanel.contains(e.target) && !materialToggle.contains(e.target)) {
        closeMaterialPanel();
      }
    }

    if (posterTooltip && posterTooltipBtn) {
      if (!posterTooltip.contains(e.target) && !posterTooltipBtn.contains(e.target)) {
        posterTooltip.classList.remove("is-open");
      }
    }
  });

  window.addEventListener("resize", function () {
    updateSize();
    syncRulersToImage();
  });

      initSizeOptions();
    initFaq();
    bindDragging();
    updateMaterialUI();
    updateSize();
  });
});